import * as React from "react";
import { Row } from "components/bootstrap";
import PageNavigation from "components/common/PageNavigation";
export const PAGE_NAVIGATION_TITLE = "AI Management";
export const MODEL_PROVIDER_TITLE = "Model Provider";
export const TOKEN_USAGE_TITLE = "Token Usage";
export const FEATURE_MODELS_TITLE = "Feature Models";
const AIManagementPageNavigation = () => /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: PAGE_NAVIGATION_TITLE }));
export default AIManagementPageNavigation;
